
import {ITEM_VIEW_TASK} from "../app-manager/item-view"
import Timer, {TimerState} from "./timer"
import Task from "../../model2/task/task"

const LSK_TIMERS = 'task_timers'
const LSK_CLOSE_TIME = 'tt_close_time'
const LSK_DOCUMENTS_COUNTER = 'tt_counter'

function formatTimeLong(ms:number) {
    const seconds = ms/1000
    return moment.unix(seconds).utc(false).format('HH:mm:ss')
}

function formatTimeShort(ms:number) {
    const seconds = ms/1000
    const format = seconds >= 3600 ? 'HH:mm' : 'mm:ss'
    return moment.unix(seconds).utc(false).format(format)
}


let needUpdateTimeAndCounter = false; // flag to save to localStorage window close time and total windows count

// const debug = "TaskTimers"
const debug = false

export default class TaskTimers {

    public timers : any = {} // taskId => timer

    constructor() {

        // this.timers = {};

        this._initFromStorage(localStorage.getItem(LSK_TIMERS), true);

        window.addEventListener('storage', e => {
            if (e.key !== LSK_TIMERS) return;

            this.timers = {};
            this._initFromStorage(e.newValue);

            // try to reload task app
            const taskView = gd.itemView.findByContainerId(ITEM_VIEW_TASK);
            if (taskView) {
                let reloadTaskApp = false;
                this._parseTimersList(e.oldValue)
                    .some((ot:any) => {
                        if (taskView.app.taskId === ot.task.id) {
                            reloadTaskApp = true;
                            return true;
                        }
                    });
                if (reloadTaskApp) taskView.app.refresh();
            }
        });
    }

    _parseTimersList(storageValue:any) {
        let list;
        try {
            list = JSON.parse(storageValue);
        } catch(e) {
            return [];
        }
        if (!list || list.length < 1) return [];
        return list;
    }

    _initFromStorage(storageValue:any, initOnLoad=false) {
        let saveNow = false;
        const list = this._parseTimersList(storageValue);

        const taskIds: ID[] = []
        list.forEach((li:any) => {
            const timer = new Timer(li.task);
            timer.deltaTime = li.time;
            timer.prevReportedTime = li.reported;
            this.timers[li.task.id] = timer;

            if (li.state === TimerState.TIMER_ACTIVE) {
                timer.startDate = new Date(li.start * 1000);

                if (initOnLoad && documentCounterGet() < 1) {
                    // only one window opened, all others where closed too
                    const closeDate = documentPrevCloseDate();
                    // @ts-ignore
                    const passedTime = new Date() - closeDate;
                    if (passedTime / 60000 > 4*60) {
                        // 4 hours passed, set a timer on pause
                        timer.state = TimerState.TIMER_ACTIVE;
                        timer.pause();
                        saveNow = true;
                    } else {
                        timer.start();
                    }

                } else {
                    // there are other active documents, safe to start timer
                    timer.start();
                }
            } else {
                timer.state = li.state;
            }

            taskIds.push(timer.task.id)
        });
        gd.bus.triggerEvent('task-timers:updated', {taskIds})

        needUpdateTimeAndCounter = list.length > 0;

        if (needUpdateTimeAndCounter) {
            documentsCounterPlus();
        }

        if (saveNow) this._saveToStorage();
    }

    _saveToStorage() {

        let list = [];

        for (let taskId in this.timers) {
            const t = this.timers[taskId];
            list.push({
                state:      t.state,
                start:      t.startDate ? t.startDate.getTime() / 1000 : null,
                time:       t.getTime(),
                reported:   t.prevReportedTime,
                task: {
                    id:         t.task.id,
                    taskTypeId: t.task.taskTypeId,
                    title:      t.task.title,
                    companyId:  t.task.companyId
                }
            });
        }

        localStorage.setItem(LSK_TIMERS, JSON.stringify(list));


        needUpdateTimeAndCounter = list.length > 0;
        if (list.length < 1) {
            localStorage.removeItem(LSK_CLOSE_TIME);
            localStorage.removeItem(LSK_DOCUMENTS_COUNTER);
        }
    }

    _addTimer(task:any) {
        let timer = this.timers[task.id];
        if (!timer) {
            timer = new Timer(task);
            this.timers[task.id] = timer;
        }
    }

    getTimer(taskId?:ID):Timer | null {
        if (!taskId) return null

        return this.timers[taskId]
    }

    isTimerActive(taskId:ID) {
        const timer = this.timers[taskId];
        if (timer) return timer.isActive();
        return false;
    }

    startTimer(task:any) {
        const taskIds = this._pauseAll()
        this._addTimer(task)
        const timer = this.timers[task.id]
        timer.start()

        taskIds.push(task.id)
        gd.bus.triggerEvent('task-timers:updated', {taskIds})

        this._saveToStorage()
    }

    _pauseAll() {
        const taskIds = []
        for (let taskId in this.timers) {
            const timer = this.timers[taskId]
            if (timer.isActive) {
                taskIds.push(taskId)
            }
            timer.pause()
        }

        return taskIds
    }

    pauseTimer(taskId:ID) {
        const timer = this.timers[taskId]
        if (!timer) return

        timer.pause()
        gd.bus.triggerEvent('task-timers:updated', {taskIds: [taskId]})
        this._saveToStorage()
    }

    removeTimer(taskId:ID) {
        const timer = this.timers[taskId]
        timer.destroy()
        delete this.timers[taskId]
        gd.bus.triggerEvent('task-timers:updated', {taskIds: [taskId]})
        this._saveToStorage()
    }

    exportToMenuItems() {
        const list = [];
        for (let taskId in this.timers) {
            const timer = this.timers[taskId];
            if (timer.task.companyId === gd.companyId || !timer.task.companyId /*for compatibility with older format without companyId*/)
                list.push(timer);
        }
        return list;
    }

    isEmpty() {
        return (!this.timers || _.isEmpty(this.timers));
    }

    formatTimeShort(ms:number) {
        return formatTimeShort(ms);
    }

    formatTimeLong(ms:number) {
        return formatTimeLong(ms);
    }

    // timer actions
    toggleTimer(task:Task) {
        if (this.isTimerActive(task.id)) {
            this.pauseTimer(task.id)
            return
        }

        this.startTimer(task)
    }

    stopTimer(taskId?:ID, baseDate?:any, callback?:callback) {
        debug && console.log(debug, taskId, baseDate)
        if (!taskId) return

        const timer = this.getTimer(taskId)
        if (!timer) return

        this.pauseTimer(taskId)
        const minDate = baseDate ? baseDate.subtract(1, 'month') : moment().subtract(1, 'month')

        gd.modals.myTime.submitTimer(
            timer,
            minDate,
            ()=>{
                this.removeTimer(taskId)
                if (callback) callback()
            }
        )
    }

    cancelTimer = (taskId?:ID, callback?:callback) => {
        if (!taskId) return

        const timer = this.getTimer(taskId)
        if (!timer) return

        if (timer.getTime() < 1) {
            // safe to remove
            this.removeTimer(taskId)
        } else {
            gd.modals.confirm.genericText("Cancel Timer","You are about to cancel a timer without submitting a time report. Are you sure ?",()=>{
                this.removeTimer(taskId)
                gd.bus.triggerEvent('task-view:time-tracking')
                gd.modal.hide()
                if (callback) callback()
            });
        }
    }
}

function documentPrevCloseDate() {
    // @ts-ignore
    let time = parseInt(localStorage.getItem(LSK_CLOSE_TIME));
    if (isNaN(time)) return new Date();

    return new Date(time);
}

function documentCounterGet() {
    // @ts-ignore
    let counter = parseInt(localStorage.getItem(LSK_DOCUMENTS_COUNTER));
    if (isNaN(counter)) counter = 0;
    return counter;
}

function documentsCounterPlus() {
    let counter = documentCounterGet();
    counter++;
    // @ts-ignore
    localStorage.setItem(LSK_DOCUMENTS_COUNTER, counter);
}

function documentsCounterMinus() {
    let counter = documentCounterGet();
    counter--;
    if (counter < 0) counter = 0;
    // @ts-ignore
    localStorage.setItem(LSK_DOCUMENTS_COUNTER, counter);
}


window.addEventListener('unload', () => {
    if (needUpdateTimeAndCounter) {
        // @ts-ignore
        localStorage.setItem(LSK_CLOSE_TIME, (new Date()).getTime());
        documentsCounterMinus();
    }
});
